import { openBlock as t, createBlock as l, resolveDynamicComponent as o, normalizeClass as n, normalizeStyle as d, withCtx as s, renderSlot as r } from "vue";
/* empty css                    */
import i from "./design-system.es128.js";
const c = {
  name: "DsText",
  props: {
    /**
     * HTML tag to render the component as
     */
    as: { type: String, default: "span" },
    /**
     * Named variant that determines the font-size, line-height, font-family and font-weight
     */
    variant: {
      type: String,
      default: null,
      validator: (a) => [
        "mega",
        "mega-alt",
        "display",
        "display-alt",
        "display-2",
        "display-2-alt",
        "headline-1",
        "headline-2",
        "headline-3",
        "headline-4",
        "headline-5",
        "body",
        "body-2",
        "mono",
        "mono-2",
        "caption",
        "x-small"
      ].includes(a)
    },
    /**
     * Color of the text where the value is a color name from the design system, e.g. `text-normal`, `text-subtle`, `blue-800`.  Does not apply a color when a value is not provided.
     */
    color: {
      type: String,
      default: null
    }
  }
};
function m(a, u, e, f, p, y) {
  return t(), l(o(e.as), {
    class: n(["ds-text", e.variant ? `ds-text--${e.variant}` : ""]),
    style: d(e.color ? `color: var(--ds-color-${e.color});` : "")
  }, {
    default: s(() => [
      r(a.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class", "style"]);
}
const v = /* @__PURE__ */ i(c, [["render", m], ["__scopeId", "data-v-74d6979b"]]);
export {
  v as default
};
//# sourceMappingURL=design-system.es106.js.map
